// extracted by mini-css-extract-plugin
export default {"logos":"SocialValidation_logos__AddjC","infiniteScrollLeft":"SocialValidation_infiniteScrollLeft__Ivzwh","labels":"SocialValidation_labels__6x8-P"};